export default __webpack_public_path__ + "static/media/pv-cuadrato.321a7a22.jpg";